import { render, staticRenderFns } from "./gameResultOthersTab.vue?vue&type=template&id=14b38202&lang=pug"
import script from "./gameResultOthersTab.vue?vue&type=script&lang=js"
export * from "./gameResultOthersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports